import { StarFilled } from "@ant-design/icons";
import { Space, Table, Tabs } from "antd";
import { RatingBadge } from "../../components/Layout/RatingBadge";
import "./Delivery.scss";
import CustomerProfile from "../Business/Customers/CustomerProfile";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DriverService from "../../services/DriverService";
import moment from "moment";

const columns = [
  {
    title: "Delivery Date",
    dataIndex: "orderId",
    key: "orderId",
    className: "theme-red",
    render: (e, record) => (
      <div>{moment(record.upatted_at).format("MM/DD/yyyy")}</div>
    ),
  },
  {
    title: "Order Id",
    dataIndex: "status",
    key: "status",
    render: (e, record) => <div>{record.order_num}</div>,
  },
  {
    title: "Pickup Address",
    dataIndex: "pickupAddress",
    key: "pickupAddress",
    render: (_, record) => (
      <RatingBadge value={record.rating}>
        {record.rating}
        <StarFilled className="ml-sm" />
      </RatingBadge>
    ),
  },
  {
    title: "Tip Recieved",
    dataIndex: "deliveryAddress",
    key: "deliveryAddress",
    render: (e, record) => <div>{record.tip}</div>,
  },
];

const DriverDetail = ({ driverId, setIsDriverAddView, setIsDetailsView }) => {
  const [driver, setDriver] = useState();
  const [driverOrders, setDriverOrders] = useState();
  const adminRestaurant = useSelector((state) => state.admin);

  useEffect(() => {
    if (driverId) {
      getDetailsById(adminRestaurant, driverId);
      getHistory(adminRestaurant, driverId);
    }
  }, [driverId, adminRestaurant]);

  const getDetailsById = async (restId, id) => {
    const data = await DriverService.getDriverDetail(restId, id);
    setDriver(data);
  };
  const getHistory = async (restId, id) => {
    const data = await DriverService.getDriverHistory(restId, id);
    setDriverOrders(data?.orders);
  };
  return (
    <Space className="w-full mt-1" direction="vertical">
      <div className="flex items-center mb-1">
              <div
                className="cursor-pointer flex"
                onClick={() => setIsDetailsView(false)}
              >
                <svg
                  width="25"
                  height="16"
                  viewBox="0 0 25 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div className="ml-2 ant-page-header-heading-title">
                {driver?.name}
              </div>
            </div>
      <div
        className="bg-white shadow-lg rounded-lg p-3 flex items-center space-between"
        style={{ paddingRight: 60, paddingLeft: 40 }}
      >
        {driver && (
          <>
            <div className="flex items-center">
              <img
                src={driver?.photo_url}
                alt="avatar"
                style={{
                  width: 100,
                  height: 100,
                  objectFit: "cover",
                  objectPosition: "top center",
                  borderRadius: "50%",
                }}
              />
              <div>
                <div className="ml-1 ant-page-header-heading-title">
                  {driver?.name}
                </div>
                <div style={{ color: "#3A3A3A" }}>{driver?.email}</div>
              </div>
            </div>
            <div>
              <RatingBadge value={driver?.average_rating}>
                {driver?.average_rating || 0}
                <StarFilled className="ml-sm" />
              </RatingBadge>
            </div>
          </>
        )}
      </div>

      <div className="text-left mt-1">
        <Tabs className="customer-tab" defaultActiveKey="active" size={"large"}>
          <Tabs.TabPane
            tab="Profile"
            key="1"
            className="bg-white shadow-lg rounded-lg p-3"
          >
            <CustomerProfile customer={driver} isDriver setIsDriverAddView={setIsDriverAddView} showEdit={true} />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Delivery History"
            className="bg-white shadow-lg rounded-lg p-3"
            key="2"
          >
            <Table columns={columns} dataSource={driverOrders} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </Space>
  );
};

export default DriverDetail;
